import { DataGrid } from "@material-ui/data-grid";
import React from "react";

const UsersTable = (props) => {
  const columns = [
    { field: "id", headerName: "ID" },
    { field: "createdOn", headerName: "נוצר" },
    { field: "displayName", headerName: "שם תצוגה" },
    { field: "email", headerName: "דואר אלקטרוני" },
    { field: "lastLogin", headerName: "כניסה לאחרונה" },
    { field: "photoURL", headerName: "תמונה" },
    { field: "score", headerName: "ניקוד" },

  ];

  const users = (props.users && props.users.map((u) => u.data)) || [];

  const rows = users.map((u,i) => {
    return {
      id:i,
      createdOn: new Date(u.createdOn.seconds * 1000).toDateString(),
      displayName: u.displayName,
      email: u.email,
      lastLogin: new Date(u.lastLogin.seconds * 1000).toDateString(),
      photoURL: u.photoURL,
      score: u.score,
    };
  });

  return (
    <div style={{ height:"80vh", width: "100%" }}>
      <DataGrid rows={rows} columns={columns} />
    </div>
  );
};

export default UsersTable;
